// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"a6734369","453":"5f51746b","463":"bdebc766"}[chunkId] + ".chunk.js";
};